import { removeGenericFromType } from "@redotech/redo-model/advanced-flow/type-system/data-types/generic-types";
import { Schema } from "@redotech/redo-model/advanced-flow/type-system/schema";

export function getDefaultPhoneNumberFieldName(schema: Schema) {
  return Object.keys(schema.fields).find(
    // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
    (key) => removeGenericFromType(schema.fields[key].dataType) === "Phone",
  );
}

export const getDefaultSmsRecipientNameFieldName = (schema: Schema) => {
  return Object.keys(schema.fields).find(
    (key) =>
      // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
      removeGenericFromType(schema.fields[key].dataType) === "Name" ||
      // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
      (removeGenericFromType(schema.fields[key].dataType) === "Text" &&
        key.toLowerCase().includes("firstname")),
  );
};
